export const getImagePath = (url: string) =>
  `${process.env.REACT_APP_BASE_URL}/storage/${url}`;
